import Wrapper from "./style"
import logo from '../../assets/logo.svg'
import { useState } from "react"
import { GetHelp } from "../getHelp"
import { Nav } from "../nav"
import Outline48Headset from '@mds/mds-icons/icons/svg/outline-48-headset.svg';

export const Header = ({names,setShowMultiSubscription,assets,multiSubscription}) => {

    const [showGetHelp, setShowGetHelp] = useState(false)

    const logout = () => {
        window.localStorage.clear()
    }

    return (
        <Wrapper>

            {
                showGetHelp
                ? <GetHelp setShowGetHelp = {setShowGetHelp} assets={assets}/>
                : null
            }

            <div className="innerHeader">
                {/* <button className="hamburger" onClick={ openHambuger }>
                    <div className="inner">
                        <div className="line1"></div>
                        <div className="line2"></div>
                        <div className="line3"></div>
                    </div>
                </button> */}
                <a href="https://www.mckinsey.com/"><img
                    className="logo"
                    src={logo}
                    alt="Mckinset Market-Sizing Assets"
                    height="42px"
                /></a>
                <Nav />
                <div className="spacer"></div>
                <input
                    type="button"
                    className="supportButton"
                    title="Support"
                    style={{
                        backgroundImage : `url(${Outline48Headset})`
                    }}
                    onClick={e => setShowGetHelp(true)}
                />
                <input
                    type="button"
                    className="user"
                    value={names.firstName && names.lastName ? (names.firstName[0] + names.lastName[0]) : 'UU'}
                />
                <div className="user-overlay">
                    <ul>
                        {
                            multiSubscription && multiSubscription.length > 1
                            ? <li>
                                <input
                                    type="button"
                                    value="Manage Subscription"
                                    title="Manage Subscription"
                                    onClick={e => setShowMultiSubscription(true)}
                                />
                            </li> : null
                        }
                        <li>
                            <input type="button" value="Logout" onClick={logout} />
                        </li>
                    </ul>
                </div>
            </div>
        </Wrapper>
    )
}